module.exports = __webpack_public_path__ + "img/image-null.d4cfbd60.jpg";